<script>
import api from './../apiBridge'
import router from './../router';
import {getQueryStringParameterByName} from './../common/utils.js'

export default {
  methods: {
    gotoLogin() {
      if (window.webkit && window.webkit.messageHandlers && window.webkit.messageHandlers.logout) {
        // native
        window.webkit.messageHandlers.logout.postMessage(null);
      } else {
        // web
        api.storeSelected = false;
        api.storeNumber = null;
        api.setStore(0);

        router.push('/login');
      }
    },

    gotoKDS() {
      router.push('/kdsPrep');
    },

    gotoBin() {
      router.push('/kdsBin');
    },

    gotoGFB() {
      router.push('/gfb');
    },

    init() {
      // check query string for store number
      let storeId = getQueryStringParameterByName('storeId')
      if (storeId) {
        api.setStore(storeId);
      }

      console.log(JSON.stringify(api));

      if (api.storeSelected && api.storeNumber) {

        api.setStore(api.storeNumber);

        if (api.station === 'gfb') {
          this.gotoGFB();
        } else if (api.station === 'bin') {
          this.gotoBin();
        } else {
          this.gotoKDS();
        }
      } else {
        if (process.env.ENABLE_WEB_LOGIN) {
          this.gotoLogin();
        } else {
          // check for storeId to be set on window by iOS app injection
          this.initInterval = setInterval(() => {
            if (window.config && window.config.storeId) {
              clearInterval(this.initInterval);

              api.initFromConfig(window.config);

              setTimeout(() => {
                console.log(JSON.stringify(api))}
                ,2000);

              if (api.station === 'bin') {
                this.gotoBin();
              } else {
                this.gotoKDS();
              }            
            }
          }, 500);
        }
      }

      setTimeout (() => {
        // login button initially hidden
        // show after some time
        this.displayLogin = true;
      }, 4000);
    }
  },

  mounted: function(){
    console.log('Main page');
    document.body.style.backgroundColor = "#000";
    
    this.init();
  },

  data() {
    return {
      displayLogin: false,
      build: process.env.build
    }
  }
}
</script>

<template>
<div class="limiter">
   <div class="container-login100" style="background-image: url('static/assets/background.jpg');">
      <div class="wrap-login100">

        <img class="login-logo" src="static/assets/logo-light.svg" />
        
         <div class="login100-form validate-form">
            
            <div v-if="displayLogin" class="container-login100-form-btn">
                <button class="login100-form-btn"  @click="gotoLogin()">
                  <i class="fas fa-sign-in-alt "></i>
                  {{$t('login')}}
                </button>
            </div>
            
         </div>
      </div>

   </div>
   <div class="" style="position:fixed;left:0px;bottom:0px;width:100%;;z-index:20">
      <table style="width:100%">
          <tr>
              <td style="color:#ffffff; padding-left:20px">
                {{$t('build_version')}}: {{build}}
              </td> 
              <td style="width:40px; padding-right:20px;">
                  <button 
                      @click="init()"
                      class="btn btn-block btn-lg btn-danger"
                      style="height: 42px; padding: 9px; font-weight: bold; border-radius: 50%; border:solid 1px #ffffff"
                      ><i class="fas fa-redo pull-left"
                      style="margin: 2px -20px 0px 0px; "
                      ></i></button>
              </td>  
          </tr> 
      </table>  
  </div>
    
    
  </div>


</template>


<style scoped>


.content-wrapper {padding:0px;}
input {
	outline: none;
	border: none;
}



input:focus::-webkit-input-placeholder { color:transparent; }
input:focus:-moz-placeholder { color:transparent; }
input:focus::-moz-placeholder { color:transparent; }
input:focus:-ms-input-placeholder { color:transparent; }
input::-webkit-input-placeholder { color: #fff;}
input:-moz-placeholder { color: #fff;}
input::-moz-placeholder { color: #fff;}
input:-ms-input-placeholder { color: #fff;}




button {
	outline: none !important;
	border: none;
  background: transparent;
  margin-right:20px;
}

button:hover {
	cursor: pointer;
}



.container-login100 {
  width: 100%;  
  min-height: 100vh;
  display: -webkit-box;
  display: -webkit-flex;
  display: -moz-box;
  display: -ms-flexbox;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
 /* align-items: center;*/
  padding: 15px;

  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
  position: relative;
  z-index: 1;  
}

.container-login100::before {
  content: "";
  display: block;
  position: absolute;
  z-index: -1;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  background-color: rgba(0,0,0,0.6);
}

.wrap-login100 {
  width: 500px;
  border-radius: 10px;
  overflow: hidden;
  padding: 55px 55px 37px 55px;
 
}
.login-logo {margin-bottom:50px;}


.login100-form {
  width: 100%;
}

.login100-form-logo {
  font-size: 60px; 
  color: #333333;

  display: -webkit-box;
  display: -webkit-flex;
  display: -moz-box;
  display: -ms-flexbox;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 120px;
  height: 120px;
  border-radius: 50%;
  background-color: #fff;
  margin: 0 auto;
}

.wrap-input100 {
  width: 100%;
  position: relative;
  border-bottom: 2px solid rgba(255,255,255,0.24);
  margin-bottom: 30px;
}

.input100 {

  font-size: 16px;
  color: #fff;
  line-height: 1.2;

  display: block;
  width: 100%;
  height: 45px;
  background: transparent;
  text-align:center;
}


.focus-input100 {
  position: absolute;
  display: block;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  pointer-events: none;
}

.focus-input100::before {
  content: "";
  display: block;
  position: absolute;
  bottom: -2px;
  left: 0;
  width: 0;
  height: 2px;

  -webkit-transition: all 0.4s;
  -o-transition: all 0.4s;
  -moz-transition: all 0.4s;
  transition: all 0.4s;

  background: #fff;
}

.focus-input100::after {
  
  font-size: 22px;
  color: #fff;

  content: attr(data-placeholder);
  display: block;
  width: 100%;
  position: absolute;
  top: 6px;
  left: 0px;
  padding-left: 5px;

  -webkit-transition: all 0.4s;
  -o-transition: all 0.4s;
  -moz-transition: all 0.4s;
  transition: all 0.4s;
}

.input100:focus {
  padding-left: 5px;
}

.input100:focus + .focus-input100::after {
  top: -22px;
  font-size: 18px;
}

.input100:focus + .focus-input100::before {
  width: 100%;
}

.has-val.input100 + .focus-input100::after {
  top: -22px;
  font-size: 18px;
}

.has-val.input100 + .focus-input100::before {
  width: 100%;
}

.has-val.input100 {
  padding-left: 5px;
}


.container-login100-form-btn {
  width: 100%;
  display: -webkit-box;
  display: -webkit-flex;
  display: -moz-box;
  display: -ms-flexbox;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
}

.login100-form-btn {
  
  font-size: 16px;
  color: #555555;
  line-height: 1.2;

  display: -webkit-box;
  display: -webkit-flex;
  display: -moz-box;
  display: -ms-flexbox;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0 20px;
  min-width: 120px;
  height: 50px;
  border-radius: 25px;

  background: #9152f8;
  background: -webkit-linear-gradient(bottom, #7579ff, #b224ef);
  background: -o-linear-gradient(bottom, #7579ff, #b224ef);
  background: -moz-linear-gradient(bottom, #7579ff, #b224ef);
  background: linear-gradient(bottom, #7579ff, #b224ef);
  position: relative;
  z-index: 1;

  -webkit-transition: all 0.4s;
  -o-transition: all 0.4s;
  -moz-transition: all 0.4s;
  transition: all 0.4s;
}

.login100-form-btn::before {
  content: "";
  display: block;
  position: absolute;
  z-index: -1;
  width: 100%;
  height: 100%;
  border-radius: 25px;
  background-color: #fff;
  top: 0;
  left: 0;
  opacity: 1;

  -webkit-transition: all 0.4s;
  -o-transition: all 0.4s;
  -moz-transition: all 0.4s;
  transition: all 0.4s;
}

.login100-form-btn:hover {
  color: #fff;
}

.login100-form-btn:hover:before {
  opacity: 0;
}
</style>


// WEBPACK FOOTER //
// Main.vue?447ea216